<div class="step ion-text-center">
    <div *ngFor="let step of steps; let index = index;"
         (click)="goToStep(step)" tappable
         class="step-indicator {{step.newChargeStepType}}"
         [ngClass]="{selected : step.selected, complete : step.complete}">
        <ion-icon [name]="step.icon" *ngIf="!step.isNotIonIcon else notIonIcon"></ion-icon>
        <ng-template #notIonIcon>
            <i [class]="step.icon"></i>
        </ng-template>
    </div>
</div>
